<template>
  <div>
    <transition mode="out-in" :name="step==1 ? 'slide-x-reverse-transition' : 'slide-x-transition'">
      <div v-if="step==1" :key="1">
        <pricing @selected="onSelected" v-model="$store.state.website.payment_section.data"></pricing>
      </div>

      <div v-else-if="step==2" :key="2">
        <v-container class="py-12">
          <v-row justify="center">
            <v-spacer></v-spacer>
            <h1 class="grey--text text--darken-3">{{$store.state.website.payment_card_title}}</h1>
            <v-spacer></v-spacer>
          </v-row>
          <v-row justify="center" class="mb-2">
            <v-col cols="12" class="text-center">
              <p
                class="mb-0 grey--text text--darken-1"
                v-text="$store.state.website.payment_card_description"
              ></p>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="12" sm="10" md="9" lg="6" xl="4">
              <v-card :loading="loading">
                <v-card-title class="py-6 white--text" :style="option.title_style">
                  <v-spacer></v-spacer>
                  <h3>{{option.title}}</h3>
                  <v-spacer></v-spacer>
                  <div class="ribbon ribbon-top-right" v-if="false">
                    <span>Best Value</span>
                  </div>
                </v-card-title>
                <v-container class="py-0" v-if="option">
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <div>
                        <span
                          style="font-size:36px"
                          class="primary--text"
                        >${{option.cycle[membership.cycle].price}}</span>
                        <span v-if="membership.cycle==='month'">/month</span>
                        <span v-if="membership.cycle==='year'">/year</span>
                      </div>

                      <!--  <div class="caption font-weight-bold">After your free 7-day trial ends</div> !-->
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider></v-divider>
                <v-container>
                  <v-row justify="center">
                    <!--
                      <v-col cols="12">
                        <v-text-field
                          readonly
                          disabled
                          :value="$store.state.user.email"
                          label="Email"
                        ></v-text-field>
                        <v-text-field v-model="$store.state.user.name" label="Name"></v-text-field>
                        <v-text-field v-model="$store.state.user.phone" label="Phone"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          label="Country"
                          :items="['Canada','United States']"
                          v-model="billing.country"
                        ></v-autocomplete>
                        <v-autocomplete
                          label="Region"
                          :items="['Alberta','Brtitish Columbia']"
                          v-model="billing.region"
                        ></v-autocomplete>
                    </v-col>!-->
                    <v-col cols="12">
                      <div class id="stripeCard"></div>
                    </v-col>
                    <v-col cols="12" class="text-center" v-if="stripe_error">
                      <span class="error--text caption">{{stripe_error}}</span>
                    </v-col>
                    <v-col cols="12" class="caption" v-html="$store.state.website.payment_terms"></v-col>
                  </v-row>
                </v-container>
                <v-card-actions class="grey lighten-4">
                  <v-btn text @click="goBack" v-if="!loading">Go Back</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    :loading="loading"
                    @click="createSubscription"
                    :disabled="!cardValid"
                  >Start Membership</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </transition>
  </div>
</template>

<script>
/**
 * Popup asking user to select a membership type and pricing option.
 * Next step asks for card info.
 *
 */

import Pricing from "@/components/page/Pricing";

export default {
  name: "Subscription",
  components: {
    Pricing
  },
  data() {
    return {
      step: 1,
      loading: false,
      show_card: false,
      membership: {
        type: "standard",
        cycle: "month"
      },
      tits: ``,
      stripe_loaded: false,
      stripe: null,
      stripe_error: "",
      cardValid: false,
      cardElement: null
    };
  },
  computed: {
    option() {
      return this.$store.state.website.payment_section.data.items.find(
        function(i) {
          return i.type === this.membership.type;
        }.bind(this)
      );
    }
  },
  watch: {},
  created() {
    if (this.$store.getters["isMember"]) {
      // this.$router.push("/portals");
    }
  },
  methods: {
    async createSubscription() {
      //get payment method from stripe.
      //send post to /user/billing with type of membersip and payment method.
      this.loading = true;
      try {
        let result = await this.stripe.createPaymentMethod(
          "card",
          this.cardElement,
          {
            billing_details: {
              email: this.$store.state.user.email,
              phone: this.$store.state.user.phone
                ? this.$store.state.user.phone
                : null,
              name: this.$store.state.user.name
            }
          }
        );
        console.log("payment method", result);
        console.log("subscription choice", this.membership);
        await this.$api.post(`/user/subscribe`, {
          payment_method: result.paymentMethod.id,
          membership: this.membership
        });
        await this.$store.dispatch("loadUser");
        this.$router.push("/subscribed");
      } catch (ex) {
        alert(ex.error ? ex.error : ex);
      }
      this.loading = false;
    },
    goBack() {
      this.step = 1;
      this.$vuetify.goTo(0);
    },
    onSelected(membership) {
      console.log("selected membership", membership);
      this.membership = membership;
      this.step = 2;
      setTimeout(
        function() {
          this.initStripe();
        }.bind(this),
        500
      );
      this.$vuetify.goTo(0);
    },
    async initStripe() {
      this.stripe = window.Stripe(this.$store.state.stripe_pk);
      this.elements = this.stripe.elements();
      var style = {
        base: {
          fontSize: "18px",
          color: "#32325d",
          fontSmoothing: "antialiased",
          "::placeholder": {
            color: "#ccc"
          }
        },
        invalid: {
          color: "#e5424d",
          ":focus": {
            color: "#303238"
          }
        }
      };
      this.cardElement = this.elements.create("card", {
        style: style
      });
      this.cardValid = false;
      this.stripe_error = false;
      this.cardElement.addEventListener(
        "change",
        function(event) {
          //alert(JSON.stringify(event))
          if (event.error) {
            this.stripe_error = event.error.message;
          } else {
            this.stripe_error = "";
          }
          if (event.complete) {
            this.cardValid = true;
          } else {
            this.cardValid = false;
          }
        }.bind(this)
      );
      this.cardElement.addEventListener(
        "ready",
        function() {
          this.stripe_loaded = true;
        }.bind(this)
      );
      this.$nextTick(() => {
        this.cardElement.mount("#stripeCard");
      });
    }
  }
};
</script>

<style>
</style>